/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Email_HintInputs */

const en_settings_profile_email_hint = /** @type {(inputs: Settings_Profile_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email can't be changed.`)
};

const id_settings_profile_email_hint = /** @type {(inputs: Settings_Profile_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email tidak bisa diubah.`)
};

/**
* | output |
* | --- |
* | "Email can't be changed." |
*
* @param {Settings_Profile_Email_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_profile_email_hint = /** @type {((inputs?: Settings_Profile_Email_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Email_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_profile_email_hint(inputs)
	return en_settings_profile_email_hint(inputs)
});